// Used to display Twikey Signing errors

import { RegistrationV2State } from "features/registration-v2/registrationV2Slice";
import { connect } from "react-redux";
import { ReduxState } from "types";
import { TwikeySigningStatus } from "components/registration/TwikeySigningStatus";
import { TeamleaderSubscriptionStatus } from "components/registration/TeamleaderSubscriptionStatus";
import { SplitPageTemplate } from "./SplitPageTemplate";
import { useNavigate } from "react-router";
import { AlertBox } from "components/AlertBox";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";


const isRegistrationSuccessfullyCompleted = (registrationState: RegistrationV2State): boolean => {
    const { twikeySignatureIsValid, teamleaderSubscriptionSuccessful } = registrationState;
    return (twikeySignatureIsValid && teamleaderSubscriptionSuccessful) ?? false;
}


export const RegistrationCompletedScreen = (props: Props) => {

    const navigate = useNavigate();
    const registrationContext = props.registration?.registrationContext;

    if (isRegistrationSuccessfullyCompleted(props.registration)) {
        navigate('/onboarding');
    }

    const FeedbackStatus = () => {
        if (!registrationContext) {
            return (
                <AlertBox type='error' icon={faTimesCircle}>
                    <p>Registration Context is not set</p>
                </AlertBox>
            )
        }
        return (
            <>
                <TwikeySigningStatus registration={props.registration} />
                <TeamleaderSubscriptionStatus registration={props.registration} />
            </>
        )
    }

    return (
        <SplitPageTemplate LeftContent={<FeedbackStatus />} />
    )
}


type StateProps = ReturnType<typeof mapStateToProps>;
type Props = StateProps;

function mapStateToProps(state: ReduxState) {
    return {
        registration: state.registration
    };
}

export default connect(mapStateToProps, null)(RegistrationCompletedScreen);